const getTop = function (element, start) {
    if (element.nodeName === 'HTML') return -start;
    return element.getBoundingClientRect().top + start;
};
const easeInOutCubic = function (t) { return t < .5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1; };

const position = function (start, end, elapsed, duration) {
    if (elapsed > duration) return end;
    return start + (end - start) * easeInOutCubic(elapsed / duration); // <-- you can change the easing function there
    // return start + (end - start) * (elapsed / duration); // <-- this would give a linear scroll
};

const Scroll = (el, duration, callback, context) => {
    duration = duration || 500;
    context = context || window;
    const start = context.scrollTop || window.pageYOffset;
    let end;

    if (typeof el === 'number') {
        end = parseInt(el);
    } else if (el && typeof el !== 'undefined') {
        end = getTop(el, start);
    } else {
        end = start;
    }

    const clock = Date.now();
    const requestAnimationFrame = window.requestAnimationFrame ||
        window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
        function (fn) { window.setTimeout(fn, 15); };

    const step = function () {
        var elapsed = Date.now() - clock;
        if (context !== window) {
            context.scrollTop = position(start, end, elapsed, duration);
        }
        else {
            window.scroll(0, position(start, end, elapsed, duration));
        }

        if (elapsed > duration) {
            if (typeof callback === 'function') {
                callback(el);
            }
        } else {
            requestAnimationFrame(step);
        }
    };
    step();
};

export { Scroll };
export default Scroll;